import React from 'react'

function ItemDamageClause() {
  return (
    <span>If any item is damaged during your visit, there will be a fee.</span>
  )
}

ItemDamageClause.propTypes = {}
ItemDamageClause.defaultProps = {}

export default ItemDamageClause



// WEBPACK FOOTER //
// ./src/components/content/itemDamageClause.js